import { createFileRoute } from '@tanstack/react-router'
import MarketingCampanhasEditorPage from '@/pages/dashboard/marketing-campanhas-editor-page'
import { RequireModule } from '@/components/auth'
import { MODULES } from '@/constants/modules'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/marketing/campanhas-segmentadas/novo',
)({
  component: function MarketingCampanhasNovoRoute() {
    const { dashboardId } = Route.useParams()

    return (
      <RequireModule module={MODULES.MARKETING} dashboardId={dashboardId}>
        <MarketingCampanhasEditorPage mode="create" />
      </RequireModule>
    )
  },
})
